(() => {
if (customElements.get('celociel-tank-offer')) return;
let instanceCount = 0;
class CelocielTankOffer extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.instance = ++instanceCount;
  this.data = JSON.parse(this.querySelector('.ce-offer__data').textContent);
  this.variants = this.data.variants.filter(v => v.available);
  this.addButton = this.querySelector('.ce-offer__add');
  this.error = this.querySelector('.ce-offer__error');
  if (!this.variants.length) { this.addButton.textContent = 'Currently sold out'; this.addButton.disabled = true; return; }
  this.colourIndex = this.data.options.findIndex(x => /colou?r/i.test(x));
  this.sizeIndex = this.data.options.findIndex(x => /size/i.test(x));
  if (this.colourIndex < 0) this.colourIndex = 0;
  if (this.sizeIndex < 0) this.sizeIndex = 1;
  this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP',currencyDisplay:'code'});
  this.offerDefinitions = [
   {quantity:1,free:0,title:'Buy 1',sub:'One easy place to start',badge:''},
   {quantity:3,free:1,title:'Buy 2, Get 1 Free',sub:'3 tanks · Mix colours and sizes',badge:'Everyday set'},
   {quantity:5,free:2,title:'Buy 3, Get 2 Free',sub:'5 tanks · Save 40% at equal prices',badge:'Best value'}
  ];
  this.cards = this.offerDefinitions.map((def, i) => this.makeCard(def, i));
  this.activate(0);
  this.addButton.addEventListener('click', () => this.addSet());
 }
 node(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
 }
 makeCard(def, index) {
  const card = this.node('div','ce-offer__card');
  if (def.badge) card.append(this.node('span','ce-offer__badge',def.badge));
  const label = this.node('label','ce-offer__label');
  const radio = this.node('input','ce-offer__radio');
  radio.type='radio'; radio.name='ce-tank-set-' + this.instance;
  radio.value=String(def.quantity); radio.addEventListener('change',() => this.activate(index));
  label.append(radio);
  if (this.data.image) { const img=this.node('img','ce-offer__image'); img.src=this.data.image; img.alt='Everyday Ease Tank'; img.width=46; img.height=58; label.append(img); }
  const copy=this.node('span','ce-offer__copy');
  copy.append(this.node('span','ce-offer__title',def.title),this.node('span','ce-offer__sub',def.sub));
  const prices=this.node('span','ce-offer__prices');
  const total=this.node('span','ce-offer__total'), was=this.node('s','ce-offer__was');
  prices.append(total,was); label.append(copy,prices); card.append(label);
  const selectors=this.node('div','ce-offer__selectors');
  const rows=[];
  for(let n=0;n<def.quantity;n++){
   const row=this.node('div','ce-offer__row');
   row.append(this.node('span','ce-offer__row-number',String(n+1)));
   const colourLabel=this.node('label','','Colour'), sizeLabel=this.node('label','','Size');
   const colour=this.node('select'), size=this.node('select');
   colour.setAttribute('aria-label','Tank '+(n+1)+' colour'); size.setAttribute('aria-label','Tank '+(n+1)+' size');
   [...new Set(this.variants.map(v=>v.options[this.colourIndex]))].forEach(value=>{const option=this.node('option','',value);option.value=value;colour.append(option);});
   const refreshSizes=()=>{
    const previous=size.value;
    size.replaceChildren();
    const prompt=this.node('option','','Select size');prompt.value='';size.append(prompt);
    this.variants.filter(v=>v.options[this.colourIndex]===colour.value).forEach(v=>{const option=this.node('option','',v.options[this.sizeIndex]);option.value=String(v.id);size.append(option);});
    if([...size.options].some(o=>o.value===previous))size.value=previous;
   };
   refreshSizes();
   colour.addEventListener('change',()=>{refreshSizes();this.updatePrice(index);});
   size.addEventListener('change',()=>{this.error.hidden=true;this.updatePrice(index);});
   colourLabel.append(colour);sizeLabel.append(size);row.append(colourLabel,sizeLabel);selectors.append(row);rows.push({colour,size});
  }
  card.append(selectors);this.querySelector('.ce-offer__cards').append(card);
  return {def,card,radio,selectors,rows,total,was};
 }
 activate(index) {
  this.selected=index;
  this.cards.forEach((c,i)=>{c.radio.checked=i===index;c.card.classList.toggle('is-selected',i===index);c.selectors.hidden=i!==index;this.updatePrice(i);});
  this.addButton.textContent=index===0?'Add my tank to cart':'Add my '+this.cards[index].def.quantity+' tanks to cart';
  this.error.hidden=true;
 }
 updatePrice(index) {
  const c=this.cards[index];if(!c)return;
  const prices=c.rows.map(row=>{
   const chosen=this.variants.find(v=>String(v.id)===row.size.value);
   if(chosen)return chosen.price;
   const candidates=this.variants.filter(v=>v.options[this.colourIndex]===row.colour.value);
   return Math.min(...candidates.map(v=>v.price));
  });
  const original=prices.reduce((a,b)=>a+b,0);
  const saving=[...prices].sort((a,b)=>a-b).slice(0,c.def.free).reduce((a,b)=>a+b,0);
  c.total.textContent=this.money.format((original-saving)/100);
  c.was.textContent=c.def.free?this.money.format(original/100):'';
  c.was.hidden=!c.def.free;
  if(index===this.selected){const summary=this.querySelector('.ce-offer__selected-total');if(summary)summary.textContent=c.total.textContent;}
 }
 async addSet() {
  const c=this.cards[this.selected];
  const missing=c.rows.find(r=>!r.size.value);
  if(missing){this.error.textContent='Choose a size for each tank in your set.';this.error.hidden=false;missing.size.focus();return;}
  const grouped=new Map();
  c.rows.forEach(r=>grouped.set(r.size.value,(grouped.get(r.size.value)||0)+1));
  const items=[...grouped].map(([id,quantity])=>({id:Number(id),quantity}));
  this.addButton.disabled=true;this.error.hidden=true;const label=this.addButton.textContent;this.addButton.textContent='Adding your set…';
  try{
   const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||'Your set could not be added. Please try again.');
   window.location.assign(this.dataset.cartUrl);
  }catch(error){this.error.textContent=error.message;this.error.hidden=false;this.addButton.disabled=false;this.addButton.textContent=label;}
 }
}
customElements.define('celociel-tank-offer',CelocielTankOffer);
})();